module.exports = __webpack_public_path__ + "static/img/discussion_member_01_ph.c5f5cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/discussion_member_01_ph.png
// module id = GR3o
// module chunks = 0